import React, { useState, useEffect } from "react";
import { BackButton } from "../shared/BackButton";
import { bm } from "./bmClient";
import { BuildingPhoto } from "./BuildingPhoto";
import { bmColors, muted } from "./bmStyles";
import { PortalRow, PortalSection } from "./PortalRow";

const fmtDay = (d) =>
  d
    ? new Date(d + "T00:00:00").toLocaleDateString("en-AU", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "";

// The profile for one building — the manager's home for that address.
//
// Booking an inspection is the first thing it does, not the only thing it is
// for: open services is a list that will grow to carry service requests and
// faults, and the sections below it are where the rest of the building's
// record will hang.
export function BMSiteProfile({
  site,
  isMobile,
  onOpenCampaign,
  onPhotoUploaded,
  onBack,
}) {
  const [campaigns, setCampaigns] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    // Open campaigns only — the endpoint filters to those, so anything that
    // comes back is something the manager can still act on.
    bm.get(`/campaigns/?site=${site.id}`)
      .then((r) => setCampaigns(r.data || []))
      .catch(() => {
        setCampaigns([]);
        setError("Could not load this building's open services.");
      });
  }, [site.id]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        <BackButton onClick={onBack} title="All sites" />
        <h1
          style={{
            fontSize: isMobile ? "18px" : "21px",
            fontWeight: "700",
            color: bmColors.darkGrey,
            margin: 0,
          }}
        >
          {site.site_name}
        </h1>
      </div>

      <BuildingPhoto
        site={site}
        isMobile={isMobile}
        onUploaded={onPhotoUploaded}
      />

      <PortalSection title="Open services" isMobile={isMobile}>
        {campaigns === null ? (
          <div style={{ ...muted, padding: "14px 8px" }}>Loading...</div>
        ) : error ? (
          <div style={{ ...muted, padding: "14px 8px", color: bmColors.red }}>
            {error}
          </div>
        ) : campaigns.length === 0 ? (
          <div style={{ ...muted, padding: "14px 8px" }}>
            Nothing open for this building at the moment.
          </div>
        ) : (
          campaigns.map((c) => (
            <PortalRow
              key={c.id}
              // The same words the page it opens is titled with, so the row
              // and the screen read as one thing.
              title="Fire Inspection Bookings"
              subtitle={[
                c.name,
                c.window_start === c.window_end
                  ? fmtDay(c.window_start)
                  : `${fmtDay(c.window_start)} – ${fmtDay(c.window_end)}`,
              ]
                .filter(Boolean)
                .join(" · ")}
              isMobile={isMobile}
              onClick={() => onOpenCampaign(c)}
            />
          ))
        )}
      </PortalSection>
    </div>
  );
}
